import { render, staticRenderFns } from "./UnverifiedUsers.vue?vue&type=template&id=2a877233"
import script from "./UnverifiedUsers.vue?vue&type=script&lang=js"
export * from "./UnverifiedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports